import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { compose } from '../../core';
import { AdminLayout, displayDataCheck, GetColumnSearchProps, getIntFromString, getOrderBy } from '../../look';
import SURVEY_ROUTE from '../../survey/route';

import ROUTE from '../route';
import {
  withAllCommentsForStoryByStoryId,
  withDeleteComment,
  withStoryFilterUpdating,
  withStoryState
} from './StoryOperations';
import { subscribeToStoryComment } from './StorySubscriptions';

const Comment = props => {
  const {
    loading,
    allCommentsForStoryByStoryId,
    onPaginationChange,
    deleteComment,
    onOrderByChange,
    orderBy,
    onFiltersRemove,
    onCommentTextChange,
    onUserChange,
    subscribeToMore
  } = props;

  React.useEffect(() => {
    const subscribe = subscribeToStoryComment(subscribeToMore /* , props.filter */);
    return () => subscribe();
  });

  const columns = [
    {
      title: 'Comment',
      key: 'commentText',
      sorter: () => onOrderByChange(getOrderBy('commentText', orderBy)),
      ...GetColumnSearchProps('commentText', onCommentTextChange),
      render: (text, record) => record && displayDataCheck(record.commentText)
    },
    {
      title: 'User',
      key: 'user',
      sorter: () => onOrderByChange(getOrderBy('user', orderBy)),
      ...GetColumnSearchProps('name', onUserChange, 'user'),
      render: (text, record) => record && displayDataCheck(`${record.user.firstName} ${record.user.lastName}`)
    },
    {
      title: 'Date',
      key: 'commentDate',
      sorter: () => onOrderByChange(getOrderBy('commentDate', orderBy)),
      render: (text, record) => `${moment(record.commentDate, 'YYYY-M-DD HH:mm:ss')}`
    }
  ];

  return (
    <AdminLayout
      table={true}
      active={ROUTE.story}
      title="Comments"
      showBack={true}
      loading={loading}
      tableData={allCommentsForStoryByStoryId}
      columns={columns}
      onDelete={deleteComment}
      // editLink={ROUTE.editCommentLink}
      // addLink={`${ROUTE.addCommentLink}${props.match.params.id}`}
      onPaginationChange={onPaginationChange}
      onFiltersRemove={onFiltersRemove}
    />
  );
};

export default compose(
  withStoryState,
  withAllCommentsForStoryByStoryId,
  withDeleteComment,
  withStoryFilterUpdating
)(Comment);
